import { useState, useEffect, useRef } from "react";

const OptimizedImage = ({
  src,
  alt,
  className,
  rootMargin = "320px",
  loading = "lazy",
  priority = false,
  fetchPriority = "auto",
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(priority);
  const imgRef = useRef(null);

  useEffect(() => {
    if (priority) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [priority, rootMargin]);

  return (
    <div
      ref={imgRef}
      className={className}
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Skeleton: opacity ile kaybolur — DOM'dan aniden kaldırılmaz */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-[#1A1A1A] to-[#0A0A0A] animate-pulse pointer-events-none"
        style={{
          opacity: isLoaded ? 0 : 1,
          transition: "opacity 0.5s ease",
          willChange: "opacity",
        }}
      />
      {isInView && (
        <img
          src={src}
          alt={alt}
          onLoad={() => setIsLoaded(true)}
          className={`${className} transition-opacity duration-500 ${isLoaded ? "opacity-100" : "opacity-0"}`}
          loading={priority ? "eager" : loading}
          fetchPriority={priority ? "high" : fetchPriority}
          decoding="async"
          style={{ willChange: "opacity" }}
          {...props}
        />
      )}
    </div>
  );
};

export default OptimizedImage;
